export default {
  "content": "<circle cx=\"50\" cy=\"50\" r=\"45\" stroke=\"#ff00cb\" stroke-width=\"8\" fill-rule=\"evenodd\"/>",
  "attrs": {
    "width": "100",
    "height": "100",
    "viewBox": "0 0 100 100",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};